import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedResult, PaginationParams } from '@core/common/models/pagination.models';
import {
  AttributeDefinitionMutationResult,
  ProductAttributeDefinition,
} from '@features/catalog/models/product-attribute-definition.models';
import { AttributeDefinitionApiService } from '@features/catalog/data-access/attribute-definition-api.service';

@Injectable()
export class CatalogAttributeDefinitionService {
  constructor(private readonly definitionApi: AttributeDefinitionApiService) {}

  list(
    filters?: { activeOnly?: boolean | null; name?: string | null },
    pagination?: PaginationParams
  ): Observable<PaginatedResult<ProductAttributeDefinition>> {
    return this.definitionApi.list(filters, pagination);
  }

  searchByName(name: string): Observable<PaginatedResult<ProductAttributeDefinition>> {
    return this.definitionApi.searchByName(name);
  }

  getById(id: string): Observable<ProductAttributeDefinition | null> {
    return this.definitionApi.getById(id);
  }

  create(input: {
    name: string;
    slug?: string | null;
    position?: number | null;
    active?: boolean;
  }): Observable<AttributeDefinitionMutationResult> {
    return this.definitionApi.create(input);
  }

  update(input: {
    id: string;
    name?: string;
    slug?: string | null;
    position?: number | null;
    active?: boolean;
  }): Observable<AttributeDefinitionMutationResult> {
    return this.definitionApi.update(input);
  }

  destroy(id: string): Observable<AttributeDefinitionMutationResult> {
    return this.definitionApi.destroy(id);
  }

  deactivate(id: string): Observable<AttributeDefinitionMutationResult> {
    return this.definitionApi.destroy(id);
  }

  reactivate(id: string): Observable<AttributeDefinitionMutationResult> {
    return this.definitionApi.updateActive(id, true);
  }

  permanentlyDelete(id: string): Observable<{ success: boolean; errors: string[] }> {
    return this.definitionApi.permanentlyDelete(id);
  }
}
